import { useTranslate } from 'hooks/useTranslate';
import { FC } from 'react';
import { Modal } from 'react-bootstrap';
import { useContributionModal } from '../context/ContributionModalContext';

const ContributionModalHeader: FC = () => {
  const { t } = useTranslate();

  const { actions } = useContributionModal();

  return (
    <Modal.Header>
      <h5 className="modal-title">{t('OtherContributions')}&nbsp;</h5>
      <a className="close cursor-pointer" onClick={actions.handleCloseModal}>
        <em className="icon ni ni-cross" />
      </a>
    </Modal.Header>
  );
};

export default ContributionModalHeader;
